<template>
    <section>
        <div
            class="px-4 py-5 sm:p-6 border-b border-gray-100"
            v-if="totalWeight > 0"
        >
            <dl>
                <dt class="text-lg leading-6 font-medium text-gray-900">
                    {{
                        t(
                            "attendees.stats.now-online-title",
                            "Momenteel online"
                        )
                    }}
                </dt>
                <dd
                    class="
                        mt-1
                        flex
                        justify-between
                        items-baseline
                        md:block
                        lg:flex
                    "
                >
                    <div
                        class="
                            flex
                            items-baseline
                            text-2xl
                            leading-8
                            font-semibold
                            text-indigo-600
                        "
                    >
                        {{ votingUsers.length }}
                        <span
                            class="
                                ml-2
                                text-sm
                                leading-5
                                font-medium
                                text-gray-500
                            "
                        >
                            {{
                                t(
                                    "attendees.stats.now-online",
                                    "van :value stemgerechtigden",
                                    totalUsers
                                )
                            }}
                        </span>
                    </div>

                    <div>
                        <center>
                            <!---->
                            <div
                                v-if="totalWeight > 0"
                                class="
                                    inline-flex
                                    items-baseline
                                    px-3
                                    py-1
                                    rounded-full
                                    text-sm
                                    font-medium
                                    leading-5
                                    md:mt-2
                                    lg:mt-0
                                "
                                :title="
                                    totalWeight +
                                    ' (' +
                                    (
                                        (onlineWeight / totalWeight) *
                                        100
                                    ).toFixed(2) +
                                    '%)'
                                "
                                :class="{
                                    'bg-green-100 text-green-800':
                                        onlineWeight > totalWeight / 2,

                                    'bg-yellow-100 text-yellow-800':
                                        onlineWeight <= totalWeight / 2,
                                }"
                            >
                                {{ onlineWeight }}
                                {{ t("attendees.stats.weight", "gewicht") }}
                            </div>
                        </center>
                    </div>
                </dd>
            </dl>

            <dl v-if="votingUsersViaProxy > 0 && showProxyStats">
                <dd
                    class="
                        mt-1
                        flex
                        justify-between
                        items-baseline
                        md:block
                        lg:flex
                    "
                >
                    <div
                        class="
                            flex
                            items-baseline
                            text-xl
                            leading-8
                            font-semibold
                            text-gray-600
                        "
                    >
                        {{ votingUsersViaProxy }}
                        <span
                            class="
                                ml-2
                                text-sm
                                leading-5
                                font-normal
                                text-gray-500
                            "
                        >
                            {{
                                t(
                                    "attendees.stats.is-online-via-proxied-users",
                                    "deelnemend via gevolmachtigde",
                                    0
                                )
                            }}
                        </span>
                    </div>

                    <div>
                        <center>
                            <!---->

                            <div
                                v-if="onlineWeightProxy > 0"
                                class="
                                    items-baseline
                                    px-3
                                    py-1
                                    rounded-full
                                    text-xs
                                    font-normal
                                    leading-3
                                    md:mt-2
                                    lg:mt-2
                                    bg-gray-100
                                    text-gray-800
                                "
                            >
                                {{ onlineWeightProxy }}
                                {{
                                    t(
                                        "attendees.stats.weight-online-now-via-proxy",
                                        "gewicht"
                                    )
                                }}
                            </div>
                        </center>
                    </div>
                </dd>
            </dl>
            <dl class="mt-4" v-if="viewersCount > 0 || true">
                <dt class="text-base leading-6 font-normal text-gray-900">
                    {{
                        t(
                            "attendees.stats.other-attendees",
                            "Overige deelnemers"
                        )
                    }}
                </dt>
                <dd
                    class="
                        mt-1
                        flex
                        justify-between
                        items-baseline
                        md:block
                        lg:flex
                    "
                >
                    <div
                        class="
                            flex
                            items-baseline
                            text-2xl
                            leading-8
                            font-semibold
                            text-indigo-600
                        "
                    >
                        {{ nonVotingUsers.length }}
                        <span
                            class="
                                ml-2
                                text-sm
                                leading-5
                                font-medium
                                text-gray-500
                            "
                        >
                            {{
                                t(
                                    "attendees.stats.online-from-others",
                                    "van :value genodigden",
                                    viewersCount
                                )
                            }}
                        </span>
                    </div>
                </dd>
            </dl>
        </div>
    </section>
</template>

<script>
import { InformationCircleIcon } from "@heroicons/vue/solid";

export default {
    components: {
        InformationCircleIcon,
    },
    mounted() {
        try {
            this.totalUsers = parseInt(
                document.head.querySelector('meta[name="users_count"]').content
            );
        } catch (error) {}
        try {
            this.totalWeight = parseInt(
                document.head.querySelector('meta[name="users_weight"]').content
            );
        } catch (error) {}
        try {
            this.viewersCount = parseInt(
                document.head.querySelector('meta[name="viewers_count"]')
                    .content
            );
        } catch (error) {}

        this.showProxyStats =
            document.head.querySelector('meta[name="show_proxy_voting_stats"]')
                .content == "true"
                ? true
                : false;

        try {
        } catch (error) {}
    },
    created() {},
    props: ["users"],
    data() {
        return {
            totalWeight: 0,
            totalUsers: 0,
            viewersCount: 0,
            showProxyStats: false,
        };
    },
    computed: {
        nonVotingUsers() {
            var self = this;
            try {
                if (this.users) {
                    return this.users.filter(function (u) {
                        return u.voting_weight <= 0 && !u.has_membertypes && !u.tts;
                    });
                }
            } catch (error) {}
            return this.users;
        },
        votingUsers() {
            var self = this;
            try {
                if (this.users) {
                    return this.users.filter(function (u) {
                        return (u.voting_weight > 0 || u.has_membertypes) && !u.tts;
                    });
                }
            } catch (error) {}
            return this.users;
        },
        votingUsersViaProxy() {
            var self = this;
            try {
                if (this.users) {
                    let permittedValues = this.users.map(function (user) {
                        return user.via_proxy;
                    });
                    return permittedValues.reduce((a, b) => a + b, 0);
                }
            } catch (error) {}
            return 0;
        },
        onlineWeight() {
            var self = this;
            try {
                if (this.users) {
                    let permittedValues = this.users.map(function (user) {
                        return user.voting_weight;
                    });
                    return permittedValues.reduce((a, b) => a + b, 0);
                }
            } catch (error) {}
            return this.users;
        },
        onlineWeightProxy() {
            var self = this;
            try {
                if (this.users) {
                    let permittedValues = this.users.map(function (user) {
                        return user.proxy_weight;
                    });
                    return permittedValues.reduce((a, b) => a + b, 0);
                }
            } catch (error) {}
            return this.users;
        },
    },
};
</script>
